import React from 'react';
import { useHistory } from 'react-router-dom';

import { ENV } from '@environment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import { Container, Header, Subheader, BackButton, NextButton, ButtonsContainer } from '../../styles';
import { TelephoneValues } from '../Telephone';
import { SuccessCircle, Phone, Stores } from './styles';

interface Props {
  telephone: TelephoneValues | null;
}

const LANDING_URL = ENV.LANDING_PAGE as string;

const JoinRappi = ({ telephone }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  if (!telephone) return null;

  const handleBack = () => history.goBack();

  const handleSubmit = () => {
    window.location.href = LANDING_URL;
  };

  return (
    <Container center>
      <SuccessCircle src="/corporate/images/success-circle.svg" />

      <Header black>{t('invite.joinRappi.title')}</Header>
      <Phone>{`${telephone.country_code.code} ${telephone.phone}`}</Phone>
      <Subheader>{htmlT(t, 'invite.joinRappi.subtitle')}</Subheader>

      <Stores>
        <a
          href="https://play.google.com/store/apps/details?id=com.grability.rappi"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img src="/corporate/images/get-mobile/google-play.svg" alt="" />
        </a>
        <a
          href="https://apps.apple.com/br/app/rappi-delivery-de-tudo-e-mais/id984044296"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img src="/corporate/images/get-mobile/app-store.svg" alt="" />
        </a>
      </Stores>

      <ButtonsContainer center>
        <BackButton type="button" onClick={handleBack}>
          {t('invite.backButton')}
        </BackButton>
        <NextButton onClick={handleSubmit}>{t('invite.joinRappi.understood')}</NextButton>
      </ButtonsContainer>
    </Container>
  );
};

export default JoinRappi;
